import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index";

export default class UsernameCheck extends React.Component {
  state = {
    submitted: false,
    username: "",
    usernameValidation: null,
    success: false
  };

  validateUsername = () => {
    if (this.state.username.length > 0 && !this.state.username.includes(" ")) {
      let error = null;
      this.setState(
        {
          usernameValidation: true
        },
        () => {
          fetch(
            "https://sydney-corp-site.builtwithdark.com/validateUsername/" +
              this.state.username,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              }
            }
          )
            .then(response => {
              if (!response.ok) {
                error = true;
              }
              return response.json();
            })
            .then(response => {
              let validationMsg = error
                ? response
                : `"${this.state.username}" is currently available`;
              this.setState({
                usernameValidation: validationMsg,
                success: !error
              });
            })
            .catch(err => {
              this.setState({
                usernameValidation: "Unexpected error: " + err
              });
            });
        }
      );
    } else {
      this.setState({
        usernameValidation:
          this.state.username.length > 0
            ? "Usernames cannot contain spaces"
            : "Usernames must be at least 3 characters"
      });
    }
  };
  copy = () => {
    this.username.select();
    document.execCommand("copy");
    this.username.blur();
  };

  render() {
    return (
      <div id={""} className={"Center "}>
        <h1 className={"large-title"}>Check if your username is available</h1>
        <div className="EmailFormWrapper">
          {this.state.usernameValidation === true ? (
            <h1 className="light-purple paragraph-text">
              {" "}
              <FontAwesomeIcon
                className="light-purple spinner"
                icon="spinner"
                spin
              />{" "}
              Validating "{this.state.username}" with server
            </h1>
          ) : (
            <p
              className={
                "paragraph-text form-error-txt light-purple " +
                (this.state.usernameValidation ? "" : "hide")
              }
            >
              {this.state.usernameValidation || ""}
            </p>
          )}
          <div className={"EmailForm "}>
            <input
              value={this.state.email}
              ref={username => (this.username = username)}
              onChange={ev =>
                this.setState({
                  username: ev.target.value,
                  success: false,
                  usernameValidation: null
                })
              }
              placeholder={"Username"}
            />
            <button
              onClick={this.state.success ? this.copy : this.validateUsername}
              className={"EmailForm-button MankSans-Medium paragraph-text"}
            >
              {this.state.success ? "Copy" : "Check"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
